<template>
  <div :class="['progress', progress === 100 ? 'progress--full' : null]">
    <div class="container">
      <span class="progress__label">Fortschritt</span>

      <div class="progress-bar">
        <div class="progress-bar__inner" :style="`width: ${progress}%;`"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      required: true,
      default: 0,
    },
  },
};
</script>

<style scoped lang="scss">
.progress {
  background-color: $color-secondary-light;
  padding: 20px 0;
  position: sticky;
  top: 0;
  z-index: map-get($z-index, progressBar);
  color: $color-white;

  &::after {
    background-color: rgba($color-white, .1);
    width: 50px;
    display: block;
    opacity: 0;
    pointer-events: none;
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    transform: skew(-45deg) translateX(-25px);
  }

  &--full::after {
    animation: reflection map-get($animation-speed, medium) linear;
    animation-delay: map-get($animation-speed, medium);
  }

  &__label {
    padding-right: $container-padding;
  }

  .container {
    display: grid;
    align-items: center;
    grid-template-columns: min-content auto;
  }
}

.progress-bar {
  background-color: rgba($color-white, .25);
  height: 6px;
  overflow: hidden;

  &__inner {
    background-color: $color-white;
    height: 6px;
    transition: width map-get($animation-speed, medium) ease;
  }
}
</style>
